import { C, S, font, fontCond } from "../constants";
import { Avatar, DeadlineChip } from "../components/ui";
import { isExpired, shortName } from "../lib/helpers";

export default function AgendaScreen({ state, me, screen, agendaView, setAgendaView, calendarDate, setCalendarDate, isMobile }) {
  const confirmed = [...state.challenges].filter(c => c.status === "agendado" && c.confirmedDate).sort((a, b) => new Date(a.confirmedDate) - new Date(b.confirmedDate));
  const pending   = [...state.challenges].filter(c => c.status !== "agendado" && c.status !== "em_mediacao").sort((a, b) => new Date(a.proposedAt) - new Date(b.proposedAt));
  const mediation = [...state.challenges].filter(c => c.status === "em_mediacao").sort((a, b) => new Date(a.proposedAt) - new Date(b.proposedAt));

  return (
    <div style={isMobile ? S.cardMobile : S.card}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <div style={S.title}>📅 Agenda de Partidas</div>
        <div style={{ display: "flex", background: C.cardAlt, border: "1px solid " + C.border, borderRadius: 8, padding: 3, gap: 3 }}>
          {[["list","☰ Lista"],["calendar","🗓 Calendário"]].map(([v, l]) => (
            <button key={v} onClick={() => setAgendaView(v)}
              style={{ background: agendaView === v ? C.primary : "transparent", color: agendaView === v ? "#fff" : C.muted, border: "none", borderRadius: 6, padding: "6px 14px", cursor: "pointer", fontWeight: 700, fontSize: 13, fontFamily: font, minHeight: 36 }}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {agendaView === "list"
        ? <ListView confirmed={confirmed} pending={pending} mediation={mediation} me={me} screen={screen} state={state} isMobile={isMobile}/>
        : <CalendarView confirmed={confirmed} state={state} me={me} calendarDate={calendarDate} setCalendarDate={setCalendarDate} isMobile={isMobile}/>
      }
    </div>
  );
}

// ── List view ──────────────────────────────────────────────────────────────────
function ListView({ confirmed, pending, mediation, me, screen, state, isMobile }) {
  return (
    <div>
      <div style={{ fontFamily: fontCond, fontWeight: 800, fontSize: 14, color: C.text, letterSpacing: .5, marginBottom: 10, textTransform: "uppercase" }}>Partidas Confirmadas</div>
      {confirmed.length === 0 && <div style={{ color: C.muted, marginBottom: 16 }}>Nenhuma partida agendada.</div>}
      {confirmed.map(c => {
        const chr = state.players.find(p => p.id === c.challengerId);
        const chd = state.players.find(p => p.id === c.challengedId);
        const dt = new Date(c.confirmedDate);
        const isMe = me && (c.challengerId === me.id || c.challengedId === me.id);
        return (
          <div key={c.id} style={{ background: isMe ? "rgba(0,168,130,.08)" : C.cardAlt, borderRadius: 10, padding: "12px 14px", marginBottom: 8, border: "1px solid " + (isMe ? C.accent + "44" : C.border) }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, flexWrap: "wrap", gap: 4 }}>
              <div style={{ fontFamily: fontCond, fontWeight: 700, fontSize: 15, color: C.primary }}>
                {dt.toLocaleDateString("pt-BR", {weekday:"short",day:"2-digit",month:"2-digit"})} — {dt.toLocaleTimeString("pt-BR", {hour:"2-digit",minute:"2-digit"})}
              </div>
              <span style={S.badge(C.success)}>Confirmada</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              {chr && <Avatar player={chr} size={30}/>}
              <span style={{ fontWeight: 700, fontSize: 13 }}>{chr ? chr.position + ". " + chr.name : c.challengerName}</span>
              <span style={{ color: C.muted, fontWeight: 700, fontSize: 12 }}>vs</span>
              {chd && <Avatar player={chd} size={30}/>}
              <span style={{ fontWeight: 700, fontSize: 13 }}>{chd ? chd.position + ". " + chd.name : c.challengedName}</span>
            </div>
          </div>
        );
      })}

      {screen === "admin" && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontFamily: fontCond, fontWeight: 800, fontSize: 14, color: C.text, letterSpacing: .5, marginBottom: 10, textTransform: "uppercase" }}>Aguardando Confirmação</div>
          {pending.length === 0 && <div style={{ color: C.muted }}>Nenhum desafio pendente.</div>}
          {pending.map(c => {
            const chr = state.players.find(p => p.id === c.challengerId);
            const chd = state.players.find(p => p.id === c.challengedId);
            const expired = isExpired(c);
            return (
              <div key={c.id} style={{ background: expired ? "#fde8ec" : C.cardAlt, borderRadius: 10, padding: "12px 14px", marginBottom: 8, border: "1px solid " + (expired ? "#e53e3e44" : C.border) }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, flexWrap: "wrap", gap: 4 }}>
                  <span style={{ fontSize: 12, color: C.muted }}>Desafio #{c.id}</span>
                  {expired ? <span style={S.badge(C.primary)}>Expirado</span> : <DeadlineChip proposedAt={c.proposedAt}/>}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  {chr && <Avatar player={chr} size={30}/>}
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{chr ? chr.position + ". " + chr.name : c.challengerName}</span>
                  <span style={{ color: C.muted, fontWeight: 700, fontSize: 12 }}>vs</span>
                  {chd && <Avatar player={chd} size={30}/>}
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{chd ? chd.position + ". " + chd.name : c.challengedName}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {screen === "admin" && mediation.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontFamily: fontCond, fontWeight: 800, fontSize: 14, color: "#8e44ad", letterSpacing: .5, marginBottom: 10, textTransform: "uppercase" }}>🛡️ Em Mediação</div>
          {mediation.map(c => {
            const chr = state.players.find(p => p.id === c.challengerId);
            const chd = state.players.find(p => p.id === c.challengedId);
            return (
              <div key={c.id} style={{ background: "#fdf5ff", borderRadius: 10, padding: "12px 14px", marginBottom: 8, border: "1px solid #8e44ad44" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ fontSize: 12, color: C.muted }}>Desafio #{c.id}</span>
                  <span style={S.badge("#8e44ad")}>Mediação</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  {chr && <Avatar player={chr} size={30}/>}
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{chr ? chr.position + ". " + chr.name : c.challengerName}</span>
                  <span style={{ color: C.muted, fontWeight: 700, fontSize: 12 }}>vs</span>
                  {chd && <Avatar player={chd} size={30}/>}
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{chd ? chd.position + ". " + chd.name : c.challengedName}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Calendar view ──────────────────────────────────────────────────────────────
function CalendarView({ confirmed, state, me, calendarDate, setCalendarDate, isMobile }) {
  const { year, month } = calendarDate;
  const monthName = new Date(year, month, 1).toLocaleDateString("pt-BR", {month:"long",year:"numeric"});
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevMonth = () => setCalendarDate(month === 0 ? {year:year-1,month:11} : {year,month:month-1});
  const nextMonth = () => setCalendarDate(month === 11 ? {year:year+1,month:0} : {year,month:month+1});

  const matchesByDay = {};
  confirmed.forEach(c => {
    const dt = new Date(c.confirmedDate);
    if (dt.getFullYear() === year && dt.getMonth() === month) {
      const d = dt.getDate();
      if (!matchesByDay[d]) matchesByDay[d] = [];
      matchesByDay[d].push(c);
    }
  });

  const blockedDaySet = new Set();
  state.blockedDates.forEach(b => {
    const bd = new Date(b.date + "T12:00:00");
    if (bd.getFullYear() === year && bd.getMonth() === month) blockedDaySet.add(bd.getDate());
  });

  const weekDays = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <button style={{ ...S.btn(C.muted, true), padding: "6px 14px" }} onClick={prevMonth}>‹</button>
        <span style={{ fontFamily: fontCond, fontWeight: 700, fontSize: 15, color: C.text, textTransform: "capitalize" }}>{monthName}</span>
        <button style={{ ...S.btn(C.muted, true), padding: "6px 14px" }} onClick={nextMonth}>›</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 2, marginBottom: 4 }}>
        {weekDays.map(d => <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: C.muted, padding: "4px 0" }}>{d}</div>)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 2 }}>
        {cells.map((d, i) => {
          const matches = d ? (matchesByDay[d] || []) : [];
          const today = new Date();
          const isToday = d && today.getFullYear() === year && today.getMonth() === month && today.getDate() === d;
          return (
            <div key={i} style={{ minHeight: 52, borderRadius: 8, background: d ? (isToday ? C.primary + "18" : blockedDaySet.has(d) ? "#fee2e2" : C.cardAlt) : "transparent", border: d ? "1px solid " + (isToday ? C.primary : blockedDaySet.has(d) ? "#fca5a5" : C.border) : "none", padding: d ? "4px 5px" : 0 }}>
              {d && <div style={{ fontSize: 12, fontWeight: isToday ? 800 : 500, color: isToday ? C.primary : blockedDaySet.has(d) ? "#dc2626" : C.muted, marginBottom: 2 }}>{d}{blockedDaySet.has(d) && <span style={{ fontSize: 8, marginLeft: 2, opacity: .7 }}>🚫</span>}</div>}
              {matches.map((c, mi) => {
                const chr = state.players.find(p => p.id === c.challengerId);
                const chd = state.players.find(p => p.id === c.challengedId);
                const isMe2 = me && (c.challengerId === me.id || c.challengedId === me.id);
                return (
                  <div key={mi} style={{ background: isMe2 ? C.accent : C.primary, color: "#fff", borderRadius: 4, padding: "2px 4px", fontSize: 9, fontWeight: 700, marginBottom: 2, lineHeight: 1.3, overflow: "hidden" }}>
                    {chr ? shortName(chr.name) : "-"} vs {chd ? shortName(chd.name) : "-"}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
